export const renewToken = `
  query renewToken {
    renew_token {
      refresh_token
      user_session
    }
  }`;
